import { render, staticRenderFns } from "./CreateAlarmReport.vue?vue&type=template&id=514a6472&scoped=true&"
import script from "./CreateAlarmReport.vue?vue&type=script&lang=js&"
export * from "./CreateAlarmReport.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlarmReport.vue?vue&type=style&index=0&id=514a6472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a6472",
  null
  
)

export default component.exports